import { toast } from "$global-providers/toast-provider";
import { Box, Button, styled, Typography } from "@material-ui/core";
import { FileCopyOutlined } from "@material-ui/icons";
import {
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../_lib/epocus-palette";
import { SettingsCard, SettingsCardLabel } from "./settings-card";

const AeTitleValue = styled(Typography)({
  fontSize: rem(20),
  fontWeight: 700,
  fontFamily: "monospace",
  color: EPOCUS_TEXT_PRIMARY,
  letterSpacing: 1,
  wordBreak: "break-all",
});

const ValueRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
});

export const ProgramAeTitleCard: FC<{ aeTitle: string }> = ({ aeTitle }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(aeTitle);
      toast.success("AE title copied");
    } catch {
      toast.error("Couldn't copy the AE title");
    }
  };

  return (
    <SettingsCard>
      <SettingsCardLabel>Program AE title</SettingsCardLabel>
      <ValueRow>
        <AeTitleValue>{aeTitle}</AeTitleValue>
        <Button
          size="small"
          variant="outlined"
          startIcon={<FileCopyOutlined />}
          onClick={handleCopy}
          style={{ textTransform: "none", flexShrink: 0 }}
        >
          Copy
        </Button>
      </ValueRow>
      <Typography style={{ fontSize: rem(12), color: EPOCUS_TEXT_SECONDARY }}>
        Set this as the destination AE title when configuring a new POCUS device
        to send studies to your program.
      </Typography>
    </SettingsCard>
  );
};
